export default "__VITE_ASSET__CgnHLInR__"